@let displayName = $displayName();
@let control = $control();
@let showHint = $showHint() && control.enabled;

<kendo-formfield [orientation]="$orientation()">
  <!-- this is necessary because Kendo bypasses the Angular lifecycle with runtime hacks,
    and throws an error prior to the content projection finalizing. It works in the real world. -->
  <input #kendoHack type="hidden" [formControl]="control" />
  <kendo-label class="k-display-block" [text]="displayName" [title]="displayName">
    <ng-content />
  </kendo-label>
  <kendo-formhint class="wrapper" [title]="$description()">
    <span class="nowrap">
      @if (showHint) {
        {{ $description() }}
      } @else {
        &nbsp;
      }
    </span>
  </kendo-formhint>
  <unity-error-wrapper ngProjectAs="kendo-formerror" [control]="control" [displayName]="displayName" />
</kendo-formfield>
